exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-badge[data-v-3c43a114] {\r\n    background-color: #c2907f;\r\n    max-width: initial !important;\n}\r\n", ""]);

// exports
